import React from "react";
import { Box, MainTitle } from "app/components/common";
import { StyleSheet } from "react-native";
import theme from "app/Theme/Theme";

interface IUserProfileBlock {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  headerContent?: any;
  mainContent: any;
}

const styles = StyleSheet.create({
  main: {
    alignSelf: "center",
    width: "100%",
    marginBottom: 15,
    paddingHorizontal: theme.spacing.sm,
    paddingVertical: theme.spacing.m,
    borderRadius: 10,
    backgroundColor: theme.colors["neutral.white"],
  },
});

export const UserProfileBlock = ({
  title,
  subtitle,
  headerContent,
  mainContent,
}: IUserProfileBlock) => {
  return (
    <Box style={styles.main}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
        marginBottom="s"
      >
        <Box>
          {title}
          {subtitle}
        </Box>
        {headerContent}
      </Box>
      <Box
        zIndex={1}
        width="100%"
        alignSelf="center"
        flexWrap="wrap"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-around"
      >
        {mainContent}
      </Box>
    </Box>
  );
};
